module.exports = __webpack_public_path__ + "img/Z60Q_18.40384e32.jpg";